import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=07f5dd50&scoped=true&"
import script from "./advantage.vue?vue&type=script&lang=ts&"
export * from "./advantage.vue?vue&type=script&lang=ts&"
import style0 from "./advantage.vue?vue&type=style&index=0&id=07f5dd50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f5dd50",
  null
  
)

export default component.exports